const messages = [
  "With Perceive Now, we slashed time-to-market by 50% and boosted customer retention by 20%.",
  "Perceive Now cut 40 hours of analysis per project and shrunk product launch timelines by 80%.",
  "Perceive Now saved us $4,000 and four weeks in startup diligence time.",
  "A game-changer in prior art search, boosting patent grant success by 70%.",
];

export default messages;
